module.exports = __webpack_public_path__ + "static/img/icon_class_wristband.54431e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_class_wristband.png
// module id = gk91
// module chunks = 1